
// src/config/app.ts
export const appConfig = {
    name: "MijnPS",
    shortName: "PS"
} as const; 